import type { IntClosedRange } from "type-fest";

export const colorVariants = (
  r: IntClosedRange<0, 255>,
  g: IntClosedRange<0, 255>,
  b: IntClosedRange<0, 255>,
) => {
  const luminance = (0.299 * r + 0.587 * g + 0.114 * b) / 255;
  return {
    withOpacity: (opacity: number) => `rgba(${r}, ${g}, ${b}, ${opacity})`,
    opaque: `rgba(${r}, ${g}, ${b}, 1)`,
    darkText: luminance > 0.5,
  };
};
